import {NgModule} from '@angular/core';
import {WebAuthnService} from './web-authn.service';

@NgModule({
    providers: [
        WebAuthnService
    ]
})
export class WebAuthnModule {}
